import styled from 'styled-components';

export const Benefit = styled.section `
background: #212121;
padding: 100px 100px;
`;

export const BenefitTitle = styled.h2 `
font-weight: 700;
font-size: 56px;
line-height: 68px;
letter-spacing: 0.01em;
color: var(--yellowDark);
padding-bottom: 200px;
strong{
   color: var(--white);
}
`;